import { ApplicationData } from "../ApplicationData";
import { AvailabilityClientManager } from "../ClientManagers/AvailabilityClientManager";
import { PrintBase } from "./PrintBase";
import { LS2PAC_Utils } from "./Utils";
import { ResourceUtils } from "./resourceUtils";

export class PrintList extends PrintBase {
  constructor() {
    super({
      dataTitle: ApplicationData.language.myLists,
    });
  }
  print(resources, name) {
    var _this = this;

    AvailabilityClientManager.getItemAvailability(resources, function () {
      _this.printResources = _this.getPrintResources(resources.slice());
      _this.getHTML(_this.printResources, name);
      _this.docName = name;
      _this.loadData();
    });
  }
  getPrintResources(resourceList) {
    var _this = this;

    var printResources = [];
    if (resourceList.length > 0) {
      $.each(resourceList, function (index, resource) {
        if (resource.rtype == 1) {
          printResources.push({
            shortTitle: resource.shortTitle,
            shortAuthor: resource.shortAuthor,
            collectionName: ResourceUtils.getCollection(resource),
            callNumber: ResourceUtils.getCallNumber(resource),
          });
        }
      });

      this.getPrintResourcesByCollection(printResources);

      printResources = [];

      $.each(_this.resourcesByCollection, function (index, resources) {
        resources.sort(LS2PAC_Utils.sortByCallNumber);
        printResources = printResources.concat(resources);
      });
    }
    return printResources;
  }
  getPrintResourcesByCollection(resources) {
    var _this = this;

    resources.sort(LS2PAC_Utils.sortByCollectionName);

    _this.resourcesByCollection = [];
    var collectionHash = {};

    $.each(resources, function (index, resource) {
      var resourcesForCollection = collectionHash[resource.collectionName];
      if (resourcesForCollection === undefined) {
        resourcesForCollection = [];
        _this.resourcesByCollection.push(resourcesForCollection);
        collectionHash[resource.collectionName] = resourcesForCollection;
      }
      resourcesForCollection.push(resource);
    });
  }
  getHTML(printResources, name) {
    var dataHTML = "<h3>" + name + '</h3><ul style="list-style: none">';
    if (printResources.length > 0) {
      $.each(printResources, function (index, printResource) {
        var shortAuthor = printResource.shortAuthor.trim();
        if (shortAuthor.length > 0 && !shortAuthor.match(/\.$/)) {
          shortAuthor += ".";
        }

        var shortTitle = printResource.shortTitle.trim();
        if (shortTitle.length > 0 && !shortTitle.match(/\.$/)) {
          shortTitle += ".";
        }

        dataHTML +=
          '<li style="padding-bottom: 10px"><u>' +
          shortTitle +
          "</u> " +
          shortAuthor +
          " " +
          ApplicationData.language.collection +
          ": " +
          printResource.collectionName +
          ", " +
          ApplicationData.language.callNumber +
          ": " +
          printResource.callNumber +
          " </li>";
      });
    } else {
      dataHTML += "<li>" + ApplicationData.language.noItemsToPrint + "</li>";
    }
    dataHTML += "</ul>";
    this.buildHTML(dataHTML);
  }
}
